import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { lsgPre } from '../../config/prefix.js';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { ActionPresentation } from '../Action/ActionPresentation.js';
import { DwindlePresentation } from '../Dwindle/DwindlePresentation.js';
import { hostClass } from './Button.styles.js';

var defaultProps = {
  look: "primary",
  onClick: function onClick() {
    /* empty */
  },
  actionRef: function actionRef() {
    /* empty */
  },
  onMouseHoverChange: function onMouseHoverChange() {
    /* empty */
  },
  onKeyboardFocusChange: function onKeyboardFocusChange() {
    /* empty */
  }
};
var ButtonPresentation = fComp(function (props) {
  var _cleanupClassObject;

  var id = props.id,
      className = props.className,
      children = props.children,
      name = props.name,
      look = props.look,
      loading = props.loading,
      disabled = props.disabled,
      onClick = props.onClick,
      htmlAttrs = props.htmlAttrs,
      noMargin = props.noMargin,
      href = props.href,
      actionRef = props.actionRef,
      hasMouseHover = props.hasMouseHover,
      onMouseHoverChange = props.onMouseHoverChange,
      hasKeyboardFocus = props.hasKeyboardFocus,
      onKeyboardFocusChange = props.onKeyboardFocusChange,
      clicked = props.clicked,
      role = props.role;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, hostClass, true), _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, "".concat(lsgPre, "no-margin"), noMargin), _cleanupClassObject)),
    role: role
  }, /*#__PURE__*/React.createElement(ActionPresentation, {
    htmlAttrs: htmlAttrs,
    disabled: disabled,
    loading: loading,
    href: href,
    name: name,
    id: id,
    onClick: onClick,
    ref: actionRef,
    onMouseHoverChange: onMouseHoverChange,
    onKeyboardFocusChange: onKeyboardFocusChange
  }, /*#__PURE__*/React.createElement(DwindlePresentation, {
    className: cleanupClassObject(_defineProperty({}, "".concat(hostClass, "__hidden"), loading)),
    look: look,
    disabled: disabled,
    hover: hasMouseHover || hasKeyboardFocus,
    clicked: clicked,
    shape: "circle-button"
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(lsgPre, "button-inner")
  }, children))));
}, defaultProps);

export { ButtonPresentation, defaultProps };
